import { post } from "shared/lib/api"

const submitMutation = (url: string, rating: number, cause: string, tags: string[], comments: string): Promise<any> =>
  post(url, { rating, cause, tags, comments })

export default submitMutation
